import { render } from "./adminLibraryVideo.vue?vue&type=template&id=4bde100f"
import script from "./adminLibraryVideo.vue?vue&type=script&lang=js"
export * from "./adminLibraryVideo.vue?vue&type=script&lang=js"

import "./adminLibraryVideo.vue?vue&type=style&index=0&id=4bde100f&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__